import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { Button, Spinner, StrokeIcon } from "./ui";

const DownloadFileButton = ({ fileId, fileName }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/files/${fileId}/download`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      setLoading(false);
    } catch (error) {
      console.error("Error while downloading the file:", error);
    }
  };

  return (
    <Button variant="ghost" onClick={handleDownload} disabled={loading} className="w-full">
      {loading ? (
        <Spinner />
      ) : (
        <StrokeIcon className="h-5 w-5">
          <path d="M12 3v12M7 12l5 5 5-5" />
          <path d="M5 21h14" />
        </StrokeIcon>
      )}
      {loading ? "Downloading…" : "Download Original File"}
    </Button>
  );
};

export default DownloadFileButton;
